import React from "react";
import { Reveal, MaskLine } from "../components/Motion";

const SHOTS = [
  { src: "/brand/graffiti.png", span: "col-span-12 sm:col-span-8", ratio: "aspect-[16/10]", cap: "01 — Pay to Park", loc: "Downtown underpass" },
  { src: "/brand/logo.png", span: "col-span-12 sm:col-span-4", ratio: "aspect-[4/5]", cap: "02 — The Stitch", loc: "Raised multicolor embroidery" },
  { src: "/brand/stairwell.png", span: "col-span-6 sm:col-span-4", ratio: "aspect-[3/4]", cap: "03 — Concrete", loc: "Brutalist stairwell" },
  { src: "/brand/jorts_back.png", span: "col-span-6 sm:col-span-4", ratio: "aspect-[3/4]", cap: "04 — Boardwalk", loc: "Golden hour, surfboards" },
  { src: "/brand/duo.png", span: "col-span-12 sm:col-span-4", ratio: "aspect-[3/4]", cap: "05 — The Pair", loc: "Concrete pillar, dusk" },
];

export default function Lookbook() {
  return (
    <div className="max-w-[1500px] mx-auto px-4 sm:px-8 py-16 sm:py-24" data-testid="lookbook-page">
      <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-graytx mb-4">Fall 2026 · Editorial</p>
      <h1 className="font-display font-extrabold text-6xl sm:text-8xl uppercase leading-[0.85]">
        <MaskLine>Lookbook</MaskLine>
      </h1>
      <p className="font-editorial italic text-2xl sm:text-3xl text-graytx mt-6 max-w-xl">
        Sun-faded, thrift-built, shot where the concrete meets the coast.
      </p>

      <div className="grid grid-cols-12 gap-4 sm:gap-6 mt-16">
        {SHOTS.map((s, i) => (
          <Reveal key={i} delay={(i % 3) * 0.08} className={s.span}>
            <div className={`${s.ratio} overflow-hidden bg-charcoal group`}>
              <img src={s.src} alt={s.cap} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="flex justify-between mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-graytx">
              <span>{s.cap}</span><span>{s.loc}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
